import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AuthenticationService } from '../services/authService/authentication.service';
import { GlobalConstants } from 'src/app/shared/services/constants/globalconstants';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  constructor(
    private router: Router,
    private authService: AuthenticationService
  ) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          const currentRoute = this.router.url;
          const isLoginRoute = currentRoute === '/' || currentRoute === '/respond' || currentRoute.startsWith('/auth/');
          const isLoginRequest = request.url.includes('/authentication/login') || request.url.includes('/respond/login');
          
          if (!isLoginRoute && !isLoginRequest) {
            const isUserOfTypeCMS = !GlobalConstants.RespondRoutes.includes(currentRoute);
            
            this.authService.logout();
            
            if (isUserOfTypeCMS) {
              this.router.navigate(['/'], { queryParams: { reason: 'session-ended' } });
            } else {
              this.router.navigate(['/respond'], { queryParams: { reason: 'session-ended' } });
            }
          }
        }
        
        return throwError(error);
      })
    );
  }
}
